import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7836266c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-rule" }
const _hoisted_2 = { class: "form-btn-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_sc_btn = _resolveComponent("sc-btn")!
  const _component_sc_page = _resolveComponent("sc-page")!

  return (_openBlock(), _createBlock(_component_sc_page, {
    title: "权限设置",
    desc: "隐藏无需设置权限"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_tree, {
          checkedKeys: _ctx.checkedKeys,
          "onUpdate:checkedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkedKeys) = $event)),
          treeData: _ctx.tree,
          "block-node": true,
          replaceFields: { key: 'id' },
          checkable: true
        }, null, 8, ["checkedKeys", "treeData"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_sc_btn, {
          type: "primary",
          handler: _ctx.submit,
          text: "保存"
        }, null, 8, ["handler"]),
        _createVNode(_component_sc_btn, {
          style: {"margin-left":"10px"},
          handler: _ctx.reset,
          text: "重置"
        }, null, 8, ["handler"])
      ])
    ]),
    _: 1
  }))
}